import styled from 'styled-components';

export const RowChartContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  width: 100% !important;
`;

export const ColumnChartContainer = styled.div`
  flex-direction: column;
  margin: 3em;
  max-width: 100%;
  flex: 1 1 500px;
`;
